import React from 'react';
import FormTemplatesList from '../components/settings/FormTemplatesList';

const FormsSettings: React.FC = () => {
  return (
    <div className="p-8 w-full h-full">
      <FormTemplatesList />
    </div>
  );
};

export default FormsSettings;

